import { HideImageRounded, PhotoRounded } from "resource/muiImport";
import { Box, Typography } from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";
import { BoxFC, BoxFR } from "components/BoxCustom";
import FullScreenImage from "pages/FullScreenImage/FullScreenImage";
import React, { useCallback, useState } from "react";

// imgHeight: when given, every thumbnail is a fixed imgWidth x imgHeight box (cover-cropped)
// instead of taking the photo's own aspect ratio
const ImagePreview = ({ title, imageItems, sx, thumbnailWidth = 450, imgWidth = 200, imgHeight }) => {

  const [curImage, setCurImage] = useState("")

  const handleImageClick = useCallback((img) => {
    setCurImage(img.imgLink)
  }, [])
  return (
    <BoxFR sx={{ width: "100%", height: "100%", alignItems: "stretch", ...sx }}>
      <BoxFC sx={{ gap: 0 }} width={thumbnailWidth}>
        {title === "" ? null :

          <BoxFR sx={{ gap: 0 }}>
            <Typography fontWeight="bold">{title}</Typography>

          </BoxFR>
        }
        <Box p={1} overflow="auto"
          bgcolor={blueGrey[50]}
          height= {title==="" ?"100%": "calc(100% - 24px)"}
        >
          {imageItems.length === 0 ?
            <BoxFC sx={{ gap: 0 }} justifyContent="center" alignItems="center" width="100%" height="100%" >
              <HideImageRounded sx={{ fontSize: 50, color: grey[500] }} />
              <Typography variant="h6" sx={{ color: grey[500] }}>ไม่พบรูปภาพ</Typography>
            </BoxFC>
            :
            // alignContent keeps the rows packed at the top instead of spread over the full height
            <BoxFR flexWrap="wrap" height="100%" sx={{ alignItems: "flex-start", alignContent: "flex-start" }}>
              {imageItems.map((item, index) => (
                <Box key={index} sx={{ p: 0.5, bgcolor: "white", borderRadius: 1, width: imgWidth, position: "relative", cursor: "pointer"
                  , outline: curImage && curImage === item.imgLink ? "3px solid" : "none", outlineColor: "primary.main" }}
                  onClick={() => { handleImageClick(item) }}>
                  <Box height={imgHeight}>
                    <img src={item.imgLink} width={"100%"} height={"100%"} alt={item.label} style={{ objectFit: imgHeight ? "cover" : "contain", display: "block" }} />
                  </Box>
                  {item.caption ? (
                    // caption: string or array of lines shown under the thumbnail
                    <BoxFC sx={{ gap: 0 }} px={0.5} pt={0.5}>
                      {[].concat(item.caption).map((line, i) => (
                        <Typography key={i} variant="caption" noWrap lineHeight={1.3} color={i === 0 ? "text.primary" : "text.secondary"}>{line}</Typography>
                      ))}
                    </BoxFC>
                  ) : null}
                </Box>
              ))}
            </BoxFR>
          }
        </Box>
      </BoxFC>
      <BoxFC flex={1} bgcolor={blueGrey[50]} borderRadius={1} height="100%"
        sx={{ justifyContent: "center", alignItems: "center" }}>
        {curImage ?
          <FullScreenImage linkUrl={curImage} />
          :
          <BoxFC sx={{ gap: 0 }} justifyContent="center" alignItems="center" width="100%" height="100%">
            <PhotoRounded sx={{ fontSize: 50, color: grey[500] }} />
            <Typography variant="h6" sx={{ color: grey[500] }}>กรุณาเลือกรูป</Typography>
          </BoxFC>
        }

      </BoxFC>
    </BoxFR>
  )

}

export default ImagePreview;